export const getModulesFromStorage = (): any[] | null => {
	if (typeof window === "undefined") return null;
	try {
		const raw = localStorage.getItem("modulesConfig");
		if (!raw) return null;
		const parsed = JSON.parse(raw);
		if (!Array.isArray(parsed) || parsed.length === 0) return null;
		return parsed;
	} catch (err) {
		console.warn("Failed to parse modulesConfig from localStorage", err);
		return null;
	}
};
